/* const configDev = {
  // ENDPOINT_URL: 'http://telemetriasignalr.smartmonitor.com.ar:8108/api',
  ENDPOINT_URL: 'http://localhost:19842/api',
  API_KEY: '',
  UPLOAD_URL: 'http://200.80.220.11:8092/api/upload',
  SIGNALR_HUB: 'http://localhost:19842/Card',
  // SIGNALR_HUB: 'http://telemetriasignalr.smartmonitor.com.ar:8108/Card',
};

const configProd = {
  ENDPOINT_URL: 'http://telemetriasignalr.smartmonitor.com.ar:8108/api',
  // ENDPOINT_URL: 'http://localhost:8092/api',
  API_KEY: '',
  UPLOAD_URL: 'http://200.80.220.11:8092/api/upload',
  // SIGNALR_HUB: 'http://localhost:8092/Card',
  SIGNALR_HUB: 'http://telemetriasignalr.smartmonitor.com.ar:8108/Card',
}; */

const config = {
  ENDPOINT_URL: '',
  API_KEY: '',
  UPLOAD_URL: '',
  SIGNALR_HUB: '',
};

export const loadConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const data = await response.json();

    config.ENDPOINT_URL = `${data.api_url}/api`;
    config.UPLOAD_URL = `${data.api_url}/api/upload`;
    config.SIGNALR_HUB = `${data.api_url}/Card`;

    console.log('config loaded', config);
  } catch (error) {
    console.error('Failed to load config.json', error);
  }
  return config;
};


// export default (process.env.NODE_ENV === 'development' ? configDev : configProd);

export default config;
